/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShippingLine } from './ShippingLine';
import {
    ShippingLineFromJSON,
    ShippingLineFromJSONTyped,
    ShippingLineToJSON,
} from './ShippingLine';

/**
 * 
 * @export
 * @interface DeliveryDriver
 */
export interface DeliveryDriver {
    /**
     * 
     * @type {string}
     * @memberof DeliveryDriver
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryDriver
     */
    handle: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryDriver
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryDriver
     */
    phone?: string;
    /**
     * 
     * @type {ShippingLine}
     * @memberof DeliveryDriver
     */
    shippingLine?: ShippingLine;
}

/**
 * Check if a given object implements the DeliveryDriver interface.
 */
export function instanceOfDeliveryDriver(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "handle" in value;

    return isInstance;
}

export function DeliveryDriverFromJSON(json: any): DeliveryDriver {
    return DeliveryDriverFromJSONTyped(json, false);
}

export function DeliveryDriverFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryDriver {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'handle': json['handle'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'shippingLine': !exists(json, 'shipping_line') ? undefined : ShippingLineFromJSON(json['shipping_line']),
    };
}

export function DeliveryDriverToJSON(value?: DeliveryDriver | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'handle': value.handle,
        'name': value.name,
        'phone': value.phone,
        'shipping_line': ShippingLineToJSON(value.shippingLine),
    };
}

